import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import LinkButton from 'flarum/common/components/LinkButton';
import SettingsPage from 'flarum/forum/components/SettingsPage';
import SessionDropdown from 'flarum/forum/components/SessionDropdown';

const t = (key) => app.translator.trans(`happydigital-notification-settings.forum.${key}`);

export default function addSettingsLinks() {
  // The grid moved to our page; other extensions' switches in this section stay.
  extend(SettingsPage.prototype, 'notificationsItems', function (items) {
    items.remove('notificationGrid');

    items.add(
      'happyNotifySettings',
      <div>
        <p className="helpText">{t('settings_link.help')}</p>
        <LinkButton className="Button" icon="fas fa-bell" href={app.route('happyNotifySettings')}>
          {t('settings_link.button')}
        </LinkButton>
      </div>,
      100
    );
  });

  extend(SessionDropdown.prototype, 'items', function (items) {
    items.add(
      'happyNotifySettings',
      <LinkButton icon="fas fa-bell" href={app.route('happyNotifySettings')}>
        {t('session_item')}
      </LinkButton>,
      49
    );
  });
}
